/* unplugin-vue-components disabled */import { render } from "./docfile.vue?vue&type=template&id=34f8b294&scoped=true"
import script from "./docfile.vue?vue&type=script&lang=js"
export * from "./docfile.vue?vue&type=script&lang=js"

import "./docfile.vue?vue&type=style&index=0&id=34f8b294&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34f8b294"],['__file',"src/components/ai-chat/ai-file/docfile.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "34f8b294"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('34f8b294', __exports__)) {
    api.reload('34f8b294', __exports__)
  }
  
  module.hot.accept("./docfile.vue?vue&type=template&id=34f8b294&scoped=true", () => {
    api.rerender('34f8b294', render)
  })

}


export default __exports__